// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../themes/Colors.css\"","icons":"hsl(24, 80%, 56%)","lines":"#e5e5e5","medal":"AllMedals_medal__CNxmk"};